import { SubscriptionTier } from './subscriptionTiers';

export interface PlanFeature {
  feature: string;
  description?: string;
  highlight?: boolean;
}

export interface SubscriptionPlan {
  tier: SubscriptionTier;
  name: string;
  price: {
    monthly: number;
    annual: number;
  };
  features: PlanFeature[];
  annualSavings?: string;
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    tier: 'FREE',
    name: 'Free',
    price: {
      monthly: 0,
      annual: 0
    },
    features: [
      { feature: 'Basic contact sharing' },
      { feature: 'Single contact profile' },
      { feature: 'Phone & email contact information only' },
      { feature: '🚫 No multiple profiles' },
      { feature: '🚫 No social media or website sharing' },
      { feature: '🚫 No address information' }
    ]
  },
  {
    tier: 'PRO',
    name: 'Pro',
    price: {
      monthly: 4.95,
      annual: 49.50
    },
    features: [
      { feature: 'Perfect for individuals who want multiple profiles and enhanced field sharing — without full business integrations.' },
      { feature: 'Up to 5 profiles (e.g. Business, Friends, Events)' },
      { feature: 'Expanded contact fields: Share phone, email, social media, website, and address' },
      { feature: '🚫 No file or gallery sharing' },
      { feature: '🚫 No advanced integrations (e.g. LinkedIn, Dropbox)' }
    ],
    annualSavings: 'Save 2 months with annual plan'
  },
  {
    tier: 'BUSINESS_PRO',
    name: 'Business Pro',
    price: {
      monthly: 9.95,
      annual: 99.50
    },
    features: [
      { feature: '🧩 Designed for professionals, agencies, and multi-brand creators who need full sharing flexibility.' },
      { feature: 'Everything in Pro, plus:', highlight: true },
      { feature: '✅ Up to 20 profiles' },
      { feature: '✅ File & gallery sharing via:', description: 'Google Drive, Dropbox, Flickr' },
      { feature: '✅ Professional integrations:', description: 'LinkedIn, GitHub, WhatsApp, Skype' },
      { feature: '✅ Links are embedded inside the downloadable vCard — no storage or hosting by us' }
    ],
    annualSavings: 'Save 2 months with annual plan'
  }
];
